module.exports = __webpack_public_path__ + "static/media/warning_icon.67350ce2.svg";